import { useState } from 'react';

/**
 * Allows to manage canvas drawing styles from outside the canvas
 */
const useStyleOperations = () => {
    const [styleForAnnotations, setStyleForAnnotations] = useState(new Map());
    const annotationHasStyle = (id, styleName) => !!(styleForAnnotations.get(id)?.name === styleName);

    const isStyleGivenToAnnotations = (styleName) =>
        Array.from(styleForAnnotations.values()).some((styleData) => styleData?.name === styleName);

    const setStyleToAnnotationsByIndexes = (style, ...annotationsId) => {
        const newStyleForAnnotations = new Map(styleForAnnotations);
        annotationsId.forEach((id) => {
            newStyleForAnnotations.set(id, style);
        });
        setStyleForAnnotations(newStyleForAnnotations);
    };

    const removeStyleFromAnnotationsByIndexes = (...annotationsId) => {
        const newStyleForAnnotations = new Map(styleForAnnotations);
        annotationsId.forEach((id) => {
            newStyleForAnnotations.delete(id);
        });
        setStyleForAnnotations(newStyleForAnnotations);
    };

    const setStyleExclusivelyToId = (setState, state, exclusiveStyle, itemId) => {
        const newState = new Map(state);
        newState.forEach((style, id) => {
            if (style.name === exclusiveStyle.name) {
                newState.delete(id);
            }
        });
        newState.set(itemId, exclusiveStyle);
        setState(newState);
    };

    const setStyleExclusivelyToAnnotationIdAndRemoveAllStyles = (style, annotationId) => {
        setStyleForAnnotations(new Map([[annotationId, style]]));
    };

    const setStyleExclusivelyToAnnotationId = (exclusiveStyle, annotationId) => {
        setStyleExclusivelyToId(setStyleForAnnotations, styleForAnnotations, exclusiveStyle, annotationId);
    };

    const removeStylesFromAnnotationsByStyleNames = (...styleNames) => {
        if (styleNames.some((styleName) => isStyleGivenToAnnotations(styleName))) {
            const newStyleForAnnotations = new Map(styleForAnnotations);
            newStyleForAnnotations.forEach((styleData, annotationId) => {
                if (styleNames.includes(styleData.name)) {
                    newStyleForAnnotations.delete(annotationId);
                }
            });
            setStyleForAnnotations(newStyleForAnnotations);
        }
    };

    return {
        setStyleToAnnotationsByIndexes,
        removeStyleFromAnnotationsByIndexes,
        annotationHasStyle,
        styleForAnnotations,
        setStyleExclusivelyToAnnotationId,
        removeStylesFromAnnotationsByStyleNames,
        setStyleExclusivelyToAnnotationIdAndRemoveAllStyles,
    };
};

export default useStyleOperations;
